import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "./NavigationBar.css";

export const NavigationBar = ({ onBackClick, title }) => {
    return (
        <div className="navigation-bar">
            <div className="nav-left">
                <button
                    className="nav-back-button"
                    onClick={onBackClick}
                    aria-label="Go back"
                >
                    <FontAwesomeIcon icon={faArrowLeft} />
                </button>
                {title && <h1 className="nav-title">{title}</h1>}
            </div>
            <div className="nav-right">
                <img src="/imgs/reino_header_logo.svg" alt="Reino Logo" className="nav-logo" />
            </div>
        </div>
    );
}; 